import axios from 'axios';

// İletişim Bulucu: kişi e-posta/telefon açma (enrich) çağrısı.
// RocketReach sonucu asenkron hazırlar; backend ~15 sn içinde hazır olmazsa
// 202 + { pending, lookup_id } döner (7 Eki 2026 — 25 sn'lik 504'lerin çözümü).
// Bu yardımcı bekleyen sonucu /people/enrich/status ucundan yoklar (kredi harcamaz).
// Apollo hiç pending döndürmez; çağrı onun için şeffaf çalışır.

const API = `${process.env.REACT_APP_API_URL}`;
const POLL_INTERVAL_MS = 3000;
const POLL_TIMEOUT_MS = 3 * 60 * 1000;

export interface EnrichPending {
  pending: true;
  lookup_id: string;
  status: string | null;
  message?: string;
}

const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

const isPending = (data: any): data is EnrichPending => !!data && data.pending === true && !!data.lookup_id;

export class EnrichTimeoutError extends Error {
  constructor() {
    super('RocketReach kişi bilgisini hâlâ hazırlıyor. Lütfen biraz sonra tekrar deneyin — hazır sonuç için yeniden kredi harcanmaz.');
    this.name = 'EnrichTimeoutError';
  }
}

/**
 * POST /{provider}/people/enrich atar; sonuç bekliyorsa hazır olana dek yoklar.
 * @param onPending İlk kez "hazırlanıyor" yanıtı geldiğinde bir kez çağrılır (toast için).
 */
export async function enrichPersonWithPolling<T = any>(
  provider: string,
  body: Record<string, unknown>,
  onPending?: (info: EnrichPending) => void,
): Promise<T> {
  const first = await axios.post(`${API}/${provider}/people/enrich`, body);
  if (!isPending(first.data)) return first.data as T;

  if (onPending) onPending(first.data);
  const lookupId = first.data.lookup_id;
  const deadline = Date.now() + POLL_TIMEOUT_MS;

  while (Date.now() < deadline) {
    await sleep(POLL_INTERVAL_MS);
    const res = await axios.get(`${API}/${provider}/people/enrich/status`, { params: { id: lookupId } });
    if (!isPending(res.data)) return res.data as T;
  }
  throw new EnrichTimeoutError();
}
